import { render, staticRenderFns } from "./SetSubject.vue?vue&type=template&id=e0476140&scoped=true"
import script from "./SetSubject.vue?vue&type=script&lang=js"
export * from "./SetSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0476140",
  null
  
)

export default component.exports